<template>
  <div class="video-player" ref="videoWrapper">    
    <div v-if="!hasBeenStarted" class="thumbnail-container" @click="playVideo">
      <img :src="thumbnailSrc" :alt="videoTitle" class="thumbnail" />
      <button class="play-button">
        <span class="arrow"></span>
      </button>
    </div>

    <video
      v-show="hasBeenStarted"
      ref="videoElement"
      :src="videoSrc"
      :poster="thumbnailSrc"
      controls
      loop
      playsinline
      @play="onPlay"
      @pause="onPause"
    ></video>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GloboPageMixin from '@/mixins/globo-page-mixin'
import { GloboPageStore } from '@/store/globo-page/globo-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class BannerVideoSection extends Mixins(GloboPageMixin) {
  globoPageStore: PageStoreContract = getModule(GloboPageStore, this.$store)

  hasBeenStarted = false
  observer: IntersectionObserver | null = null

  get videoTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get videoSrc(): string {
    return this.getElementMedia(0, 0)
  }

  get thumbnailSrc(): string {
    return this.getElementMedia(0, 1)
  }

  async getGloboPage(): Promise<void> {
    await this.globoPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.globoPageStore.isLoading) {
      await this.getGloboPage()
    }
    this.setupIntersectionObserver()
  }

  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01, 
    }

    this.observer = new IntersectionObserver(this.handleIntersection, options)

    const videoWrapper = this.$refs.videoWrapper as HTMLElement
    if (videoWrapper) {
      this.observer.observe(videoWrapper)
    }
  }

  handleIntersection(entries: IntersectionObserverEntry[]) {
    const videoElement = this.$refs.videoElement as HTMLVideoElement
    if (!videoElement || !this.hasBeenStarted) return

    const entry = entries[0]
    if (entry.isIntersecting) {
      videoElement.play().catch(error => {
        console.warn('A reprodução foi bloqueada pelo navegador:', error)
      })
    } else {
      videoElement.pause()
    }
  }

  playVideo() {
    this.hasBeenStarted = true
    this.$nextTick(() => {
      const videoElement = this.$refs.videoElement as HTMLVideoElement
      if (videoElement) {
        videoElement.muted = false 
        videoElement.play().catch(error => {
          console.error('Erro ao tentar tocar o vídeo:', error)
          this.hasBeenStarted = false 
        })
      }
    })
  }

  onPlay() {
    console.log('Vídeo iniciado.')
  }

  onPause() {
    console.log('Vídeo pausado.')
  }
}
</script>

<style lang="scss">
.video-player {
  position: relative;
  cursor: pointer;
  width: 100%;  
}

.thumbnail-container {
  position: relative;
}

.thumbnail,
video {
  width: 100%;
  height: auto;
  display: block;
}

.play-button {
  position: absolute;
  bottom: 20px; 
  left: 20px;   
  background: transparent;
  border: 2px solid white;
  border-radius: 50%;
  width: 49px;
  height: 49px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;  
}

.play-button .arrow {
  width: 0;
  height: 0;
  border-top: 11.88px solid transparent;
  border-bottom: 11.88px solid transparent;
  border-left: 16.33px solid white;
  margin-left: 5px;
}
</style>
